<div class="form-subcontainer">
    <div class="form-content">
        <!--<div class="form-header">
            <button clickable="" class="btn-close"><svg xmlns="http://www.w3.org/2000/svg" width="17.657"
                    height="17.657" viewBox="0 0 17.657 17.657">
                    <g _ngcontent-kcr-c822="" id="Group_12987" data-name="Group 12987"
                        transform="translate(-5669.475 -484.975)">
                        <line _ngcontent-kcr-c822="" id="Line_325" data-name="Line 325" x2="12" y2="12"
                            transform="translate(5672.304 487.804)" fill="none" stroke="#bebfbe" stroke-linecap="round"
                            stroke-width="4"></line>
                        <line _ngcontent-kcr-c822="" id="Line_326" data-name="Line 326" x1="12" y2="12"
                            transform="translate(5672.304 487.804)" fill="none" stroke="#bebfbe" stroke-linecap="round"
                            stroke-width="4"></line>
                    </g>
                </svg></button>
            <h2 class="form-title">Contact Us</h2>
        </div>-->
        <div>
            <form class="fpx-form-group">
                <section class="contactus-container">
                    <div class="titleholDer">                        
                        
                        <h4><span><img src="./assets/images/icons/cont_phone-call.svg"></span>
                        {{'CONTACTUS.callus' | translate}}</h4>
                    </div>
                    
                    <div class="call-us">
                        <div class="address">
                            <div class="reg_off">
                                <div><small>{{'CONTACTUS.withinegypt' | translate}}</small></div>
                                <div><span class="phone"><a href="javascript:void(0)" (click)="callPhone('CONTACTUS.hotline')">{{'CONTACTUS.hotline' | translate}}</a></span>
                                </div>        
                            </div>
                            <div class="cor_off">
                            <div><small>{{'CONTACTUS.outside' | translate}}</small></div>
                            <div class="phone">
                                <!-- <span class="phone">
                                    <a href="javascript:void(0)" onclick="window.open('tel:+0020221283100', '_system')">
                                        {{'CONTACTUS' | translate}}
                                    </a>
                                </span> -->
                                <!-- <span>to</span> -->
                                <span class="phone"><a href="javascript:void(0)" (click)="callPhone('CONTACTUS.hotline2')" >{{ 'CONTACTUS.hotline2' | translate }}</a></span>
                            </div>
                            </div>
                        </div>
                    </div>
                    <div class="email">
                        <h4>
                            <span>
                                <img src="./assets/images/icons/mail-icon.svg">
                            </span>
                            {{'CONTACTUS.email' | translate}}</h4>
                        
                        <span>
                            <a href="javascript:void(0)" (click)="openMail('CONTACTUS.supportMail')">{{ 'CONTACTUS.supportMail' | translate }}</a>
                        </span>

                    </div>
                    <div class="website">
                        <h4><span><img src="./assets/images/icons/website-icon.svg"></span>
                            {{'CONTACTUS.website' | translate}}

                        </h4>

                        
                        <!--<span><a href="https://www.creditcorporation.com.pg/" target="_system">{{ 'CONTACTUS.web' | translate }}</a></span>-->
                        <span><a href="https://www.creditbank.com.pg/" target="_system">{{ 'CONTACTUS.web' | translate }}</a></span>

                    </div>
                    <div class="follow">
                        <h4>{{'CONTACTUS.follow' | translate}}</h4>
                        <ul>
                            <li class="media-facebook">
                                <span>
                                    <a href="javascript:void(0)" target="_system" (click)="openLink('CONTACTUS.facebookLink')">
                                        <img src="./assets/images/icons/cont_facebook.svg" alt="facebook" />
                                    </a>
                                </span>
                                {{'CONTACTUS.facebook' | translate}}
                            </li>
                            <li class="media-linkedin">
                                <span>
                                    <a href="javascript:void(0)" target="_system"
                                    (click)="openLink('CONTACTUS.linkedinLink')">
                                        <img src="./assets/images/icons/cont_linkedin.svg" alt="linkedin" />
                                    </a>
                                </span>
                                {{'CONTACTUS.linkedin' | translate}}
                            </li>

                            <!--<li class="media-instagram">
                                <span>
                                    <a href="javascript:void(0)" target="_system"
                                        (click)="openLink('CONTACTUS.instagramLink')">
                                        <img src="./assets/images/icons/instagram-icon.svg" alt="instagram" />
                                    </a>
                                </span>
                                {{'CONTACTUS.instagram' | translate}}
                            </li>-->
                        </ul>
                    </div>
                </section>
            </form>
        </div>
    </div>
</div>
